__webpack_require__.p = "/VestaStay/";